<template>
	<Transition name="slide-fade">
		<div v-if="isVisible" class="cookie-panel">
			<article>
				<p>Мы используем файлы <a @click.prevent="onClickCookieLink">cookie</a> для улучшения работы сайта и повышения удобства пользователей.</p>
				<ActionButton @click="acceptCookie" small>Согласен</ActionButton>
			</article>
		</div>
	</Transition>
</template>

<style src="./CookiePanel.scss" lang="scss"/>

<script lang="ts">

import ActionButton from '@/pages/common/MainPage/components/ActionButton/ActionButton.vue';
import ContractsPublicService from "@/domains/Contracts/ContractsPublicService";

export default defineComponent({
	name: "CookiePanel",

	components: {
		ActionButton
	},

	data() {
		return {
			isVisible: false
		};
	},

	mounted() {
		const cookieAccepted = localStorage.getItem('cookieAccepted');
		if (!cookieAccepted) {
			this.isVisible = true;
		}
	},

	methods: {
		acceptCookie() {
			localStorage.setItem('cookieAccepted', 'true');
			this.isVisible = false;
		},

    async onClickCookieLink() {
      // чтобы отправить к самой актуальной версии, нужно сначала узнать её айди
      const contractsPublic = await ContractsPublicService.getList({ id: 'userConfidential' }, undefined, undefined, true)
      this.$router.push(`/list/contracts-public/userConfidential/${contractsPublic[0].version}`);
    },
	}
});
</script>

